export class SitePopupController {
    static init(): void {
        const popups = Array.from(document.querySelectorAll<HTMLDialogElement>("[data-site-popup]"));
        if (popups.length === 0) return;

        const isHiddenToday = (popup: HTMLDialogElement): boolean =>
            document.cookie.split(";").some((cookie) =>
                cookie.trim() === `pichi_popup_${popup.dataset.sitePopup}=hidden`,
            );
        const pending = popups.filter((popup) => !isHiddenToday(popup));
        let active: HTMLDialogElement | undefined;

        const position = (): void => {
            if (!active?.open) return;
            const rect = active.getBoundingClientRect();
            const coordinate = (value: string | undefined, viewport: number, size: number): number => {
                const match = (value ?? "").trim().match(/^(\d+(?:\.\d+)?)(px|%)$/);
                const requested = match
                    ? Number(match[1]) * (match[2] === "%" ? viewport / 100 : 1)
                    : (viewport - size) / 2;
                return Math.max(12, Math.min(requested, viewport - size - 12));
            };

            active.style.setProperty("--popup-left", `${coordinate(active.dataset.popupLeft, window.innerWidth, rect.width)}px`);
            active.style.setProperty("--popup-top", `${coordinate(active.dataset.popupTop, window.innerHeight, rect.height)}px`);
        };

        const showNext = (): void => {
            active = pending.shift();
            if (!active) return;
            const width = Number(active.dataset.popupWidth) || 420;
            active.style.setProperty("--popup-width", `${Math.max(100, Math.min(2000, width))}px`);
            active.showModal();
            position();
        };

        pending.forEach((popup) => {
            popup.querySelector("[data-popup-close]")?.addEventListener("click", () => popup.close());
            popup.querySelector("[data-popup-hide-today]")?.addEventListener("click", () => {
                const midnight = new Date();
                midnight.setHours(24, 0, 0, 0);
                const secure = window.location.protocol === "https:" ? "; Secure" : "";
                document.cookie = `pichi_popup_${popup.dataset.sitePopup}=hidden; expires=${midnight.toUTCString()}; path=/; SameSite=Lax${secure}`;
                popup.close();
            });
            popup.addEventListener("close", showNext);
            popup.querySelector("img")?.addEventListener("load", position);
        });

        window.addEventListener("resize", position);
        showNext();
    }
}
